import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/advertising/index',
    name: 'advertisingIndex',
    component: () => import('@/sub-app/advertising/pages/index.vue'),
    meta: {
      title: '',
      keepAlive: true,
    },
  },
  {
    path: '/advertising/detail',
    name: 'advertisingDetail',
    component: () => import('@/sub-app/advertising/pages/detail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/advertising/submitDetail',
    name: 'advertisingSubmitDetail',
    component: () => import('@/sub-app/advertising/pages/submitDetail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/advertising/success',
    name: 'advertisingSuccess',
    component: () => import('@/sub-app/advertising/pages/success.vue'),
    meta: {
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/advertising/myAppointment',
    name: 'advertisingMyAppointment',
    component: () => import('@/sub-app/advertising/pages/myAppointment.vue'),
    meta: {
      title: '我的预约',
      keepAlive: true,
    },
  },
  {
    path: '/advertising/orderDetail',
    name: 'advertisingOrderDetail',
    component: () => import('@/sub-app/advertising/pages/orderDetail.vue'),
    meta: {
      title: '预约详情',
      keepAlive: false,
    },
  },
  {
    path: '/advertising/myAuditList',
    name: 'advertisingMyAuditList',
    component: () => import('@/sub-app/advertising/pages/myAuditList.vue'),
    meta: {
      title: '',
      keepAlive: true,
    },
  },
  {
    path: '/advertising/auditDetail',
    name: 'advertisingAuditDetail',
    component: () => import('@/sub-app/advertising/pages/auditDetail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
